import React from 'react';
import {RouterProvider, createBrowserRouter} from 'react-router-dom';

import {NotFoundPage} from 'presentation/components';
import {useFeatureFlagsQuery} from 'presentation/queries/useFeatureFlagsQuery';
import {FullscreenLoading} from 'presentation/components/Loading/FullscreenLoading';
import {translations} from 'presentation/translations-new';
import {FeaturesEnum} from 'presentation/constants';
import {useMultipleFeatureFlags} from 'presentation/hooks/useMultipleFeatureFlags';
import {getOtherRoutes, getPrivateRoutes, getPublicRoutes} from '.';
import {RouterListener} from './routerListener';

const {loading} = translations['pt-br'].commons;

export function Router() {
	const {isLoading: isLoadingFeatureFlags} = useFeatureFlagsQuery();
	const financialFlags = useMultipleFeatureFlags({
		isEnabledCopartV3: FeaturesEnum.PORTAL_FEATURE_COPART,
		isEnabledNewIncomeTax: FeaturesEnum.PORTAL_FEATURE_ARCHITECTURE_MVVM_INCOME_TAX,
		isEnabledNewReferrals: FeaturesEnum.PORTAL_FEATURE_ARCHITECTURE_MVVM_REFERRALS,
	});

	if (isLoadingFeatureFlags) {
		return <FullscreenLoading text={loading} />;
	}

	const router = createBrowserRouter([
		{
			element: <RouterListener />,
			errorElement: <NotFoundPage />,
			children: [
				...getPublicRoutes(),
				...getPrivateRoutes(financialFlags),
				...getOtherRoutes(),
			],
		},
	]);

	return <RouterProvider router={router} />;
}
